import React, { FC, ReactNode, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { Calendar, CalendarProps } from '../calendar/index';
import { Popover, PopoverContent, PopoverTrigger } from '../popover/index';

type OverlayDatePickerProps = {
  calendar?: Except<CalendarProps, 'initialFocus' | 'mode' | 'selected'>;
  children: ReactNode;
  defaultMonth?: Date;
  disabled?: boolean;
  isDefaultOpenCalendar?: boolean;
  onSelect?: (date: Date) => void;
  value?: Date | null;
  wrapperClassName?: string;
};

/** Overlay trigger (required children + click catcher). Same Calendar as DatePicker / FormDatePicker. */
export const OverlayDatePicker: FC<OverlayDatePickerProps> = ({
  children,
  onSelect,
  value,
  isDefaultOpenCalendar,
  wrapperClassName,
  calendar,
  disabled = false,
  defaultMonth,
}) => {
  const [isOpenCalendar, setOpenCalendar] = useState(isDefaultOpenCalendar ?? false);

  return (
    <Popover onOpenChange={setOpenCalendar} open={isOpenCalendar}>
      <PopoverTrigger className={twMerge('relative w-full cursor-pointer', wrapperClassName)}>
        <div
          className="absolute z-[100] h-full w-full"
          onClick={() => setOpenCalendar((prev) => !prev)}
        />
        {children}
      </PopoverTrigger>
      <PopoverContent className="z-[100] w-auto p-0">
        <Calendar
          defaultMonth={defaultMonth}
          {...calendar}
          disabled={disabled}
          initialFocus
          mode="single"
          onSelect={(date) => {
            if (!date) return;
            setOpenCalendar(false);
            onSelect?.(date);
          }}
          selected={value || undefined}
        />
      </PopoverContent>
    </Popover>
  );
};
